import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { gaReducer } from "./GA";
import Gettext from "./common/Gettext";
import Button from "./Button";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  max-width: 479px;
  padding: 1.5em;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1.5;
  color: #414141;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #fff;
  text-align: center;
  z-index: 17000000;
  box-shadow: 0px 0px 3px #ccc;

  @media all and (display-mode: standalone) {
    display: none;
  }
`;

const Content = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  margin-bottom: 10px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: 100%;
`;

const CancelButton = styled.span`
  color: #a7a7a7;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
`;

const AllowButton = styled(Button)`
  width: auto;
  min-width: 8.75em;
  margin-left: auto;
  user-select: none;
`;

const STORAGE_KEY = "a2hs";

export default function AddToHomeScreen(props) {
  let gaSent = false;
  let setupWebapp = window.setupWebapp;

  const wrongPages = ["/fillup", "/verification", "/sightseeing"];
  const inTheWrongPlaceAtTheWrongTime = wrongPages.reduce((isWrongPage, page) => {
    if (isWrongPage) return true;

    return window.location.pathname.startsWith(page);
  }, false);

  // Chrome will show mini-infobar starting from 68 version
  // https://developers.google.com/web/updates/2018/06/a2hs-updates
  const chromeCheck = /Chrome\/(\d+)/.exec(window.navigator.userAgent);
  const chromeIsShowingInfobar =
    props.isMobile && chromeCheck && parseInt(chromeCheck[1], 10) >= 68;

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [display, setDisplay] = useState(false);

  const eventHandler = e => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    setDeferredPrompt(e);
  };

  const clickHandler = () => {
    setDisplay(false);
    // window.setupWebapp = null;

    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === "accepted") {
          gaReducer("WEBAPP_INSTALL");
          console.log("User accepted the A2HS prompt");
        } else {
          gaReducer("WEBAPP_DECLINE");
          console.log("User dismissed the A2HS prompt");
        }
        setDeferredPrompt(null);
      });
    }

    gaReducer("WEBAPP_ACCEPT");
  };

  const closeHandler = () => {
    try {
      localStorage.setItem(STORAGE_KEY, Date.now());
    } catch (error) {}

    setDeferredPrompt(null);
    setDisplay(false);
    // window.setupWebapp = null; // crashes somewhat somehow if open on /setup-webapp

    gaReducer("WEBAPP_NOTNOW");
  };

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", eventHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", eventHandler);
    };
  }, []);

  useEffect(() => {
    if (setupWebapp) {
      setDisplay(true);

      return null;
    }

    let storage;
    try {
      storage = localStorage.getItem(STORAGE_KEY);
    } catch (error) {}

    setDisplay(true);

    if (storage) {
      const then = new Date(parseInt(storage, 10));
      const now = new Date();
      const silentPeriod = 1;
      // Do not display the popup if user closed it earlier today
      if (Math.abs(then.getDate() - now.getDate()) <= silentPeriod) {
        setDisplay(false);
      }
    }
  }, [setupWebapp]);

  if (
    inTheWrongPlaceAtTheWrongTime ||
    chromeIsShowingInfobar ||
    !deferredPrompt ||
    !display
  ) {
    return null;
  }

  if (!gaSent) {
    gaReducer("WEBAPP_SHOW");
    gaSent = true;
  }

  return (
    <Container>
      <Content>
        <Gettext>
          We have a smooth and fantastic web-app version of our website. Please
          allow the browser to add it to your home screen.
        </Gettext>
      </Content>
      <Buttons>
        <CancelButton onClick={closeHandler}>
          <Gettext>NO THANKS</Gettext>
        </CancelButton>
        <AllowButton color="green" onClick={clickHandler}>
          <Gettext>ALLOW</Gettext>
        </AllowButton>
      </Buttons>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/AddToHomeScreen.js